module.exports = __webpack_public_path__ + "static/media/HalfOrc.5e3f0c66.png";